/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { forwardRef } from "react";

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// Material Dashboard 2 React components
import MDTypography from "../MDTypography";

// Custom styles for MDProgress
import MDProgressRoot from "../MDProgress/MDProgressRoot";

const MDProgress = forwardRef(({ variant, color, value, label, valuelabel, ...rest }, ref) => (
  <>
    
    {label && (
     
      <MDTypography variant="button" fontWeight="medium" color="text">
        {valuelabel === null || valuelabel === ''? value : valuelabel}%
      </MDTypography>
    )}
    <MDProgressRoot
      {...rest}
      ref={ref}
      variant="determinate"
      value={value > 100 ? 100 : value}
      ownerState={{ color, value, variant }}
    />
  </>
));

// Setting default values for the props of MDProgress
MDProgress.defaultProps = {
  variant: "contained",
  color: "info",
  value: 0,
  label: false,
};

// Typechecking props for the MDProgress
MDProgress.propTypes = {
  variant: PropTypes.oneOf(["contained", "gradient"]),
  color: PropTypes.oneOf([
    "primary",
    "secondary",
    "info",
    "success",
    "warning",
    "error",
    "light",
    "dark",
    "purple",
    "teal",
    "cyan",
    "amber",
    "lime",
    "indigo",
    "deepPurple",
    "deepOrange",
    "pink",
    "brown",
    "grey",
    "blueGrey",
    "limeGreen",
    "orange",
    "blue",
    "green",
    "red",
    "yellow",
    "violet",
    "turquoise",
    "magenta",
    "cyan",
    "azure",
    "lavender",
    "rose",
    "ivory",
    "peach",
    "salmon",
    "chartreuse",
    "olive",
    "mustard",
    "maroon",
    "plum",
    "navy",
    "steelBlue",
    "slateGrey",
    "sienna",
    "goldenrod",
    "peru",
    "thistle",
    "orchid",
    "cornflowerBlue",
    "cadetBlue",
    "mediumPurple",
    "darkOrchid",
    "darkSlateBlue",
    "saddleBrown",
    "fireBrick",
  ]),

  value: PropTypes.number,
  label: PropTypes.bool,
};

export default MDProgress;
